export const getElementPosition = (element) => {
    const position = { x: 0, y: 0 };
    let localElement = element;

    if (localElement.offsetParent) {
        do {
            position.x += localElement.offsetLeft;
            position.y += localElement.offsetTop;
            localElement = localElement.offsetParent;
        } while (localElement);
    }

    return position;
};

function isElementVisible(element) {
    if (!element || !element.parentNode) {
        return false;
    }

    const style = window.getComputedStyle(element);

    return (
        style.display !== 'none'
        && style.visibility !== 'hidden'
        && parseFloat(style.opacity) > 0
        && element.offsetWidth > 0
        && element.offsetHeight > 0
    );
}

export const getFocusableComponents = containerElement => [
    ...containerElement.querySelectorAll([
        'a[href]:not([hidden])',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        '[tabindex="0"]'
    ].join(', '))]
    .filter(element => (element?.getAttribute('tabIndex') ?? 0) >= 0)
    .filter(isElementVisible);
